import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    detection: {
      // check navigator first, then localStorage, then cookie
      order: ['navigator', 'localStorage', 'cookie'],
      // store detected language in localStorage and cookie
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
  }, (err, t) => {
    if (err) {
      console.error('i18next init failed:', err);
    } else {
      // console.log('i18next initialized successfully');
      // console.log('Detected language:', i18n.language); 
    }
  });

// log all available languages
// console.log('Available languages:', i18n.languages);

// log navigator language for debugging
// console.log('Navigator language:', navigator.language);
// console.log('Navigator languages:', navigator.languages);

// log what is currently in localStorage for i18next
// console.log('LocalStorage i18nextLng:', localStorage.getItem('i18nextLng'));

export default i18n;
